import React, { Fragment } from 'react';
import ToolbarContainer from './components/ToolbarContainer';
import createStore from '../utils/createStore';
import { DEFAULT_STATE, open, openPrompt as _openPrompt, closePrompt as _closePrompt, close, expand, collapse, setHoverButton, isCommand, moveUp, moveDown, moveLeft, moveRight, commit, dismiss } from './state';
import EmptyPlaceholder from '../../components/Editor/EmptyPlaceholder';
import './style.css';
import BlockTypes, { TYPOGRAPHIC_BLOCKS } from '../../types/BlockTypes';
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      containerId = _ref.containerId,
      _ref$contentInsets = _ref.contentInsets,
      contentInsets = _ref$contentInsets === void 0 ? {} : _ref$contentInsets;

  // Insets are internal safe margins inside the editor. Toolbar will avoid
  // these zones when scrolling.
  var insets = {
    top: contentInsets.top || 0,
    bottom: contentInsets.bottom || 0,
    left: contentInsets.left || 0,
    right: contentInsets.right || 0
  };
  var store = createStore({
    state: DEFAULT_STATE
  });
  var placeholder = React.createElement(Fragment, null, "Type", ' ', React.createElement("span", {
    className: "background-shade-50 radius-normal flexbox-align-center flexbox-justify-center",
    style: {
      display: 'inline-flex',
      width: 24,
      height: 24
    }
  }, React.createElement("span", null, "/")), ' ', "to browse options");
  var previousSelection;
  return [{
    commands: {
      openToolbar: function openToolbar(editor) {
        return store.updateItem('state', open, editor);
      },
      openPrompt: function openPrompt(editor, prompt) {
        return store.updateItem('state', _openPrompt, editor, prompt);
      },
      closePrompt: function closePrompt(editor, prompt) {
        return store.updateItem('state', _closePrompt, editor, prompt);
      },
      closeToolbar: function closeToolbar(editor) {
        return store.updateItem('state', close, editor);
      },
      dismissToolbar: function dismissToolbar(editor) {
        return store.updateItem('state', dismiss, editor);
      },
      expandToolbar: function expandToolbar(editor) {
        return store.updateItem('state', expand, editor);
      },
      collapseToolbar: function collapseToolbar(editor) {
        return store.updateItem('state', collapse, editor);
      },
      setToolbarHoverButton: function setToolbarHoverButton(editor, button) {
        return store.updateItem('state', setHoverButton, editor, button);
      },
      applyToolbarButton: function applyToolbarButton(editor) {
        return commit(store.getItem('state'), editor);
      }
    },
    queries: {
      isToolbarInsertion: function isToolbarInsertion(editor) {
        return (editor.isEmptyBlock() && editor.isActiveBlock(TYPOGRAPHIC_BLOCKS) || editor.isToolbarCommand()) && editor.value.selection.isCollapsed;
      },
      isToolbarSelection: function isToolbarSelection(editor) {
        return editor.value.selection.isExpanded && editor.value.fragment.text !== '';
      },
      isToolbarCommand: function isToolbarCommand(editor) {
        return isCommand(editor);
      },
      isToolbarOpen: function isToolbarOpen() {
        return store.getItem('state').isOpen === true;
      },
      isToolbarPromptOpen: function isToolbarPromptOpen() {
        return store.getItem('state').isPrompt === true;
      },
      canOpenToolbar: function canOpenToolbar(editor) {
        return !editor.readOnly && editor.value.selection.isSet && editor.value.startBlock.type !== BlockTypes.CODE;
      }
    }
  }, {
    onChange: function onChange(editor, next) {
      var selection = editor.value.selection;
      if (previousSelection === selection) return next();
      var returnValue = next();
      var shouldCloseBefore = previousSelection && previousSelection.isExpanded && selection.isCollapsed;
      previousSelection = selection;

      if (!editor.canOpenToolbar()) {
        editor.closeToolbar();
        return returnValue;
      }

      if (selection.isBlurred) {
        if (editor.isToolbarPromptOpen()) {
          return returnValue;
        }

        editor.closeToolbar();
        return returnValue;
      }

      if (editor.isToolbarInsertion() || editor.isToolbarSelection()) {
        if (shouldCloseBefore) {
          editor.closeToolbar();
        }

        editor.openToolbar();
      } else {
        editor.closeToolbar();
      }

      return returnValue;
    },
    renderBlock: function renderBlock(props, editor, next) {
      if (editor.readOnly) return next();
      if (!props.isFocused) return next(); // Only focused blocks

      if (props.node.type !== BlockTypes.UNSTYLED) return next(); // Only default blocks

      if (props.node.text !== '') return next(); // Block should be empty

      if (props.node.getIn(['data', 'depth']) > 0) return next(); // Not in indented blocks

      if (props.editor.value.selection.isExpanded) return next(); // We don't want selection across empty blocks

      if (props.parent.text === '') return next(); // Document placeholder is displayed

      return React.createElement("div", props.attributes, React.createElement(EmptyPlaceholder, Object.assign({
        placeholder: placeholder
      }, props), next()));
    },
    onKeyDown: function onKeyDown(event, editor, next) {
      var state = store.getItem('state');
      if (!state.isOpen || state.isDismissed) return next();

      if (event.metaKey || event.altKey || event.shiftKey || event.ctrlKey) {
        return next();
      }

      var handleAction = function handleAction(method) {
        event.preventDefault();
        store.updateItem('state', method, editor);
      };

      if (event.key === 'Escape') {
        return handleAction(dismiss);
      }

      if (!state.isExpanded && state.command === null) {
        return next();
      }

      switch (event.key) {
        case 'Enter':
        case 'Tab':
          {
            event.preventDefault();
            return commit(store.getItem('state'), editor);
          }

        case 'ArrowUp':
          return handleAction(moveUp);

        case 'ArrowDown':
          return handleAction(moveDown);

        case 'ArrowLeft':
          return handleAction(moveLeft);

        case 'ArrowRight':
          return handleAction(moveRight);

        default:
          return next();
      }
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(ToolbarContainer, {
        editor: editor,
        store: store,
        insets: insets,
        containerId: containerId
      }, next());
    }
  }];
});